import SettingsContainer from "./Settings.Container";

export default SettingsContainer;
